/**
 * @generated SignedSource<<807f14a6727502766a91ba3ca66e8140>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentLabelSelectorDropdownListItemFragment$data = {
  readonly defaultContentTypes: string;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"ContentLabelSelectorDropdownListItemOverflowFragment" | "ContentLabelUpdateFormFragment">;
  readonly " $fragmentType": "ContentLabelSelectorDropdownListItemFragment";
};
export type ContentLabelSelectorDropdownListItemFragment$key = {
  readonly " $data"?: ContentLabelSelectorDropdownListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentLabelSelectorDropdownListItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentLabelSelectorDropdownListItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultContentTypes",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentLabelUpdateFormFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentLabelSelectorDropdownListItemOverflowFragment"
    }
  ],
  "type": "ContentLabel",
  "abstractKey": null
};

(node as any).hash = "8740df82d29ddbcf78bd4e5e92b7d18a";

export default node;
